export default (state = { roles: ['member'] }, action = {}) => state; // user never changes

// TRY THIS: change 'member' to 'admin' to access private area (see src/routesMap.js)
